import { LucideIcon } from "lucide-react";
import { Card, CardContent } from "@b2b/ui-components";

import { cn } from "../../lib/utils";

interface KPICardProps {
  title: string;
  value: string | number;
  change?: {
    value: number;
    isPositive: boolean;
  };
  icon: LucideIcon;
  className?: string;
}

export function KPICard({
  title,
  value,
  change,
  icon: Icon,
  className,
}: KPICardProps) {
  return (
    <Card
      className={cn("hover:shadow-lg transition-all duration-200", className)}
    >
      <CardContent className="p-6">
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <p className="text-sm font-medium text-muted-foreground mb-1">
              {title}
            </p>
            <p className="text-3xl font-bold text-foreground">{value}</p>
            {change && (
              <p
                className={cn(
                  "text-sm font-medium mt-1",
                  change.isPositive ? "text-green-600" : "text-red-500"
                )}
              >
                {change.isPositive ? "+" : ""}
                {change.value}% from last month
              </p>
            )}
          </div>
          <div className="w-12 h-12 rounded-lg bg-orange-100 flex items-center justify-center">
            <Icon className="h-6 w-6 text-orange-500" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
